export default "__VITE_ASSET__2x8Q7Dhs__"